import { useAcceptOffer, useDeclineOffer } from "../../../api/query_hooks/offer";
import { Accordion, Button, Card, useAccordionButton } from "react-bootstrap";
import Propic from "../../../components/images/propic/Propic";
import { getPropicUrl } from "../../../api/endpoints";

const ReceivedOfferDetails = ({eventKey, offer}) => {

    const acceptMutation = useAcceptOffer();
    const declineMutation = useDeclineOffer();

    const acceptOffer = () => {
        acceptMutation.mutate(offer.id);
    };

    const declineOffer = () => {
        declineMutation.mutate(offer.id);
    };


    return (
        <Card className="bg-darker">
            <Card.Header className="p-0 m-0 border-2 border-black rounded-0">
                <AccordionButton 
                    eventKey={eventKey}
                    className="bg-darker hov-bg-1 flex-between col-12 p-3 border-0 rounded-0"
                >
                    <p className="m-0">{offer.user.username}</p>
                    <p className="m-0">{offer.price} €</p>
                    <p className="px-1 m-0 text-small border rounded">{offer.status}</p>
                </AccordionButton>
            </Card.Header>
            <Accordion.Collapse eventKey={eventKey}>
                <Card.Body className="py-2 border-bottom border-2 border-black">
                    <div className="flex-between gap-2">
                        <div className="flex-center flex-grow-1 gap-2 justify-content-start">
                            <Propic className="w-4" src={getPropicUrl(offer.user.propic)} />
                            <div className="d-flex flex-column">
                                <p className="m-0">mail: {offer.user.email}</p>
                                <p className="m-0">website: {offer.user.website}</p>
                            </div>
                        </div>
                        <div className="d-flex gap-2">
                            {offer.status === "PENDING" &&
                                <>
                                    <Button variant="success" type="button" onClick={acceptOffer} disabled={offer.status !== "PENDING"}>Accept</Button>
                                    <Button variant="danger" type="button" onClick={declineOffer} disabled={offer.status !== "PENDING"}>Decline</Button>
                                </>
                            }
                        </div>
                    </div>
                </Card.Body>
            </Accordion.Collapse>
        </Card>
    );
};

const AccordionButton = ({ children, eventKey, className="" }) => {

    const accordionOnClick = useAccordionButton(eventKey);


    return (
        <Button
            variant="dark"
            type="button"
            onClick={accordionOnClick}
            className={className}
        >
            {children}
        </Button>
    );
}


export default ReceivedOfferDetails;